// extracted by mini-css-extract-plugin
export default {"container":"menu__container___ql90l","menuHorizontal":"menu__menuHorizontal___RdlO_","menuVertical":"menu__menuVertical___NRhsv"};